import React from "react";

export default function Stepper({ stepper = [], completedLevelsCount = 0 }) {
  const currentLevel = completedLevelsCount + 1;

  const stepClass = (lvl) => {
    if (lvl <= completedLevelsCount) return "marketing_level_step_done";
    if (lvl === currentLevel) return "marketing_level_step_current";
    if (lvl === currentLevel + 1) return "marketing_level_step_next";
    if (lvl === 10) return "marketing_level_step_max";
    return "marketing_level_step_locked";
  };

  const icon = (lvl) => {
    if (lvl <= completedLevelsCount) return <i className="bi bi-check-lg" />;
    if (lvl === currentLevel) return <i className="bi bi-person-fill" />;
    if (lvl === currentLevel + 1) return <span className="fw-bold">{lvl}</span>;
    if (lvl === 10) return <i className="bi bi-trophy-fill" />;
    return <i className="bi bi-lock-fill" />;
  };

  return (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
      <div className="card-body">
        <h5 className="fw-bold mb-1">10-Tier Roadmap Journey</h5>
        <p className="small marketing_level_text_muted">
          Track your milestone journey across all operational ranks from Bronze Starter to Star Elite.
        </p>

        {/* Dynamic Legend */}
        <div className="d-flex flex-wrap gap-3 small mb-4">
          <span>
            <i
              className="bi bi-circle-fill marketing_level_text_green me-1"
              style={{ fontSize: 9 }}
            />
            {completedLevelsCount > 0
              ? `Completed (${completedLevelsCount >= 1 ? `Level 1` : ""}${
                  completedLevelsCount > 1 ? `–${completedLevelsCount}` : ""
                })`
              : "Completed (None yet)"}
          </span>
          <span>
            <i
              className="bi bi-circle-fill marketing_level_text_blue me-1"
              style={{ fontSize: 9 }}
            />
            Current Standing (Level {Math.min(10, currentLevel)})
          </span>
          <span>
            <i
              className="bi bi-circle-fill marketing_level_text_muted me-1"
              style={{ fontSize: 9 }}
            />
            Locked ({Math.min(10, currentLevel + 1)}–10)
          </span>
        </div>

        {/* Stepper Scroll Container */}
        <div className="overflow-auto pb-2">
          <div className="d-flex align-items-start" style={{ minWidth: 820 }}>
            {stepper.map((s, i) => {
              const isCurrent = s.lvl === currentLevel;
              const isDone = s.lvl <= completedLevelsCount;

              return (
                <div
                  key={s.lvl}
                  className="flex-fill text-center position-relative"
                >
                  {isCurrent && (
                    <span
                      className="badge bg-primary position-absolute start-50 translate-middle-x"
                      style={{ top: -22, fontSize: 9, whiteSpace: "nowrap" }}
                    >
                      YOU ARE HERE
                    </span>
                  )}

                  {i > 0 && (
                    <div
                      className={`position-absolute ${
                        s.lvl <= completedLevelsCount + 1 && isDone
                          ? "marketing_level_step_line_done"
                          : "marketing_level_step_line"
                      }`}
                      style={{
                        height: 3,
                        top: 18,
                        left: "-50%",
                        width: "100%",
                      }}
                    />
                  )}

                  <div
                    className={`position-relative rounded-circle d-inline-flex align-items-center justify-content-center ${stepClass(
                      s.lvl
                    )}`}
                    style={{ width: 38, height: 38, zIndex: 1 }}
                  >
                    {icon(s.lvl)}
                  </div>

                  <div
                    className={`small fw-semibold mt-2 ${
                      isCurrent ? "marketing_level_text_blue" : ""
                    }`}
                  >
                    {s.label}
                  </div>
                  <div
                    className={`small ${
                      s.lvl === 10
                        ? "marketing_level_text_gold fw-bold"
                        : "marketing_level_text_muted"
                    }`}
                    style={{ fontSize: 11 }}
                  >
                    {s.rate}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

